// extracted by mini-css-extract-plugin
module.exports = {"user_wrapper":"User__user_wrapper___zwtEM","name":"User__name___1cnfV","learning":"User__learning___2XcE6"};